module.exports = __webpack_public_path__ + "static/seamoss-c11c0840334d752cd8f4943d94ad36e6.png";